// These factors are specific to formula fields belonging to ideas. At present some logic / enums are shared with RoadmapFactors to reduce duplication.
export enum CalculationInsightCountFactors {
  companyInsightCount = 'companyInsightCount', // the number of insights but grouped by unique companies
  insightCount = 'insightCount',
  niceToHaveInsightCount = 'niceToHaveInsightCount',
  importantInsightCount = 'importantInsightCount',
  mustHaveInsightCount = 'mustHaveInsightCount',
}

export enum CalculationCompanySpendFactors {
  monthlySpend = 'monthlySpend',
  annualSpend = 'annualSpend',
}

// TODO: extends to support opportunity factors once we have opportunity links for ideas
export const AllCalculationFactors = [
  ...Object.values(CalculationInsightCountFactors),
  ...Object.values(CalculationCompanySpendFactors),
];

export type DefaultFactors = CalculationInsightCountFactors | CalculationCompanySpendFactors;
